import { IAIChatItem, streamToAnswerItemWithMarkdown } from '@dauyan/ai-chat';
import { logError } from '@/utils/logger/arms-config';
import { getReadingReference } from '@/utils/audioPlay';
import i18n from '@/locales/init'; 

export interface IListeningAIRemoteItem {
  ai_content: string;
  content: string;
  id: number;
  paper_id: string;
  type: string;
  analyze: string;
}

// 题目解析数据
const getAnalyzeLocalData = (ele: any & { type: 'Analysis'; }): IAIChatItem => {
  const question_id = ele.question_id;
  const reference = getReadingReference(question_id);
  const contentData = typeof (ele as any).analyze === 'string' ? JSON.parse(ele.analyze) : null;

  return {
    id: `${ele.id}`,
    type: ele.type,
    question: contentData.question,
    reference,
    answer: contentData.answer,
  };
};

const normalGetLocalData = (ele: any): IAIChatItem => {
  
  const reference: any = {};
  if ((ele as any).reference) {
    reference.content = (ele as any).reference.content;
    reference.payload = (ele as any).reference.payload ? JSON.parse((ele as any).reference.payload): '';
  }

  // if (ele.question && ele.response) {
  return {
    id: `${ele.id}`,
    type: ele.type || 'Asking',
    question: ele.question,
    reference,
    answer: streamToAnswerItemWithMarkdown(ele.response),
  };
  // }
};

export const remoteToLocal = (remote: IListeningAIRemoteItem): IAIChatItem => {
  try {
    switch (remote.type) {
      case 'Analysis': {
        return getAnalyzeLocalData({ ...remote, type: 'Analysis' });
      }
      default: {
        return normalGetLocalData(remote);
      }
    }
  } catch (e) {
    logError(new Error(`AI会话记录解析错误：remoteId=${remote.id}`));
    return {
      id: `${remote.id}`,
      type: remote.type,
      question: i18n.t('common.dauyan_no_data_found'),
      answer: [{
        key: Date.now().toString(),
        content: i18n.t('common.dauyan_no_data_found'),
        type: 'stream-text',
      }],
    };
  }

};
